import React from 'react';
import { Check, ClipboardList, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import DrawerShell from '@/components/DrawerShell';
import ReferralSubmittedFormView from './ReferralSubmittedFormView';

const STAGE_LABEL = {
  review_1: 'Review 1',
  review_2: 'Review 2',
  approval: 'Final approval',
};

/** Right-side drawer to review the submitted referral before Approve / Reject. */
export default function ReferralApprovalDetailDrawer({
  open, row, onClose, onDecide, busy, intent = null,
}) {
  const stage = STAGE_LABEL[row?.fic_stage] || row?.fic_stage || 'Review';
  const patient = row?.patient?.name || 'Patient';
  const doctor = row?.preferred_doctor?.name || row?.preferred_doctor_name;
  const highlightApprove = intent === 'approve';
  const highlightReject = intent === 'reject';

  return (
    <DrawerShell
      open={open}
      onClose={onClose}
      accent="#071B34"
      width="lg"
      testId="referral-approval-drawer"
      eyebrow="Referral approval"
      title={row?.request_number || 'Submitted form'}
      subtitle={`${patient} · ${row?.seeking?.specialisation || 'Referral'}${doctor ? ` → Dr ${doctor}` : ''}`}
      icon={<ClipboardList className="h-5 w-5" />}
      headerExtras={(
        <span className="inline-flex rounded-full bg-white/20 px-2.5 py-0.5 text-[11px] font-semibold ring-1 ring-white/30">
          Your stage · {stage}
        </span>
      )}
      footer={(
        <>
          {intent ? (
            <p className="mr-auto text-xs text-[#5A6B7C] max-w-[200px]">
              Opened from email — confirm {intent === 'approve' ? 'approval' : 'rejection'} below.
            </p>
          ) : null}
          <Button type="button" variant="outline" onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            type="button"
            variant="outline"
            className={`border-red-200 text-red-700 hover:bg-red-50 ${highlightReject ? 'ring-2 ring-red-400' : ''}`}
            disabled={busy || !row?.id}
            onClick={() => onDecide?.(row.id, 'rejected')}
            data-testid="referral-drawer-reject"
          >
            <X className="mr-1 h-3.5 w-3.5" /> Reject
          </Button>
          <Button
            type="button"
            className={`text-white ${highlightApprove ? 'ring-2 ring-offset-2 ring-emerald-500' : ''}`}
            style={{ background: '#F15A22' }}
            disabled={busy || !row?.id}
            onClick={() => onDecide?.(row.id, 'approved')}
            data-testid="referral-drawer-approve"
          >
            <Check className="mr-1 h-3.5 w-3.5" /> Approve
          </Button>
        </>
      )}
    >
      <ReferralSubmittedFormView row={row} />
    </DrawerShell>
  );
}
